/**
 * Watch reference patterns for service identification.
 *
 * Ported from legacy breitling-storefront-next `lib/util.ts` — service flows
 * use these patterns, not the broader Algolia search SKU regex.
 */

const WATCH_SKU_REGEX = /^[A-Za-z][A-Za-z0-9]{11}\d$/;
const WATCH_SKU_FIRST_SIX_REGEX = /^[A-Za-z][A-Za-z0-9]{5}$/;

export function isWatchSku(value: string): boolean {
  return WATCH_SKU_REGEX.test(value.trim());
}

export function isWatchSkuFirstSix(value: string): boolean {
  return WATCH_SKU_FIRST_SIX_REGEX.test(value.trim());
}

export function isWatchReferenceInput(value: string): boolean {
  const trimmed = value.trim();
  return isWatchSkuFirstSix(trimmed) || isWatchSku(trimmed);
}
